module.exports = "query GetCardCollections {\n  collections(limit: 20) {\n    ...CollectionFragment\n  }\n}\n"